import React from "react";

function Instagram() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="url(#paint0_linear_1720_19766)"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#fff"
        d="M16.339 5.54H8.912a3.725 3.725 0 00-3.72 3.72v6.797a3.725 3.725 0 003.72 3.722h7.427c2.051 0 3.72-1.67 3.72-3.722V9.26a3.725 3.725 0 00-3.72-3.722zM6.504 9.26a2.411 2.411 0 012.408-2.408h7.427a2.411 2.411 0 012.408 2.409v6.796a2.412 2.412 0 01-2.408 2.409H8.912a2.411 2.411 0 01-2.408-2.41V9.262z"
      ></path>
      <path
        fill="#fff"
        d="M12.626 16.12a3.465 3.465 0 003.46-3.462 3.465 3.465 0 00-3.46-3.462 3.465 3.465 0 00-3.461 3.462 3.465 3.465 0 003.46 3.462zm0-5.61a2.15 2.15 0 012.148 2.149 2.15 2.15 0 01-2.148 2.149 2.15 2.15 0 01-2.149-2.149 2.15 2.15 0 012.149-2.149zM16.406 9.755a.934.934 0 000-1.865.933.933 0 000 1.865z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1720_19766"
          x1="4.131"
          x2="21.124"
          y1="21.155"
          y2="4.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAD4F"></stop>
          <stop offset="0.35" stopColor="#DD2A7B"></stop>
          <stop offset="0.62" stopColor="#9537B0"></stop>
          <stop offset="1" stopColor="#515BD4"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Instagram;
